import type { PaywallProduct } from '@segmently/schema-models/payments';

export type PickerTab = 'test' | 'live';
export type PaywallProvider = 'stripe' | 'paddle';
export const PROVIDER_LABEL: Readonly<Record<PaywallProvider, string>> = Object.freeze({
  stripe: 'Stripe', paddle: 'Paddle',
});

/** Legacy products without a provider are Stripe, as in the product converter. */
export function providerOf(product: Pick<PaywallProduct, 'paymentProvider'>): PaywallProvider {
  return product.paymentProvider === 'paddle' ? 'paddle' : 'stripe';
}

/** Missing environment is unassigned, never inferred from another provider's field. */
export function productTabOf(product: PaywallProduct): PickerTab | null {
  if (providerOf(product) === 'paddle') {
    if (product.paddleEnvironment === 'sandbox') return 'test';
    if (product.paddleEnvironment === 'production') return 'live';
    return null;
  }
  return product.mode === 'test' || product.mode === 'live' ? product.mode : null;
}

export function environmentLabelOf(product: PaywallProduct): string | null {
  const tab = productTabOf(product);
  if (!tab) return null;
  return providerOf(product) === 'paddle'
    ? (tab === 'test' ? 'Sandbox' : 'Production')
    : (tab === 'test' ? 'Test' : 'Live');
}
